import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    } else {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-lg shadow-lg border-b border-gray-200' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_axicle-robotics/artifacts/urvypt34_Full%20Text%20Logo.svg" 
              alt="Axicle Robotics" 
              className="h-8 sm:h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-sm font-medium"
            >
              Product
            </button>
            <button 
              onClick={() => scrollToSection('benefits')}
              className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-sm font-medium"
            >
              Benefits
            </button>
            <button 
              onClick={() => scrollToSection('audience')}
              className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-sm font-medium"
            >
              Solutions
            </button>
            <button 
              onClick={() => scrollToSection('video')}
              className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-sm font-medium"
            >
              Demo
            </button>
            <button 
              onClick={() => navigate('/about')}
              className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-sm font-medium"
            >
              About Us
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-red-600 hover:bg-red-700 text-white transition-colors duration-200"
              size="default"
            >
              Contact Us
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-900 p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white backdrop-blur-lg border-t border-gray-200">
            <nav className="flex flex-col space-y-4 py-6">
              <button 
                onClick={() => scrollToSection('features')}
                className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-left px-4"
              >
                Product
              </button>
              <button 
                onClick={() => scrollToSection('benefits')}
                className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-left px-4"
              >
                Benefits
              </button>
              <button 
                onClick={() => scrollToSection('audience')}
                className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-left px-4"
              >
                Solutions
              </button>
              <button 
                onClick={() => scrollToSection('video')}
                className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-left px-4"
              >
                Demo
              </button>
              <button 
                onClick={() => { navigate('/about'); setIsMobileMenuOpen(false); }}
                className="text-gray-700 hover:text-red-600 transition-colors duration-200 text-left px-4"
              >
                About Us
              </button>
              <div className="px-4 pt-2">
                <Button 
                  onClick={() => scrollToSection('contact')}
                  className="bg-red-600 hover:bg-red-700 text-white w-full"
                >
                  Contact Us
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
